import { render, staticRenderFns } from "./CardContact.vue?vue&type=template&id=58371116"
import script from "./CardContact.vue?vue&type=script&lang=js"
export * from "./CardContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports